
import axios from "axios";
export default {
  props: [],
  data() {
    return {
    }
  },
  mounted() {   
    
  },
  methods: {
    concactUs() {
      this.$emit('handleConcactUs')
    },
  }
}
